export type ENV_NEXT_PUBLIC_ENVIRONMENT = 'prod' | 'staging' | 'dev'

export const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod'
